var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.model != null
    ? _c("div", [
        _vm.model.isMFAChallenge
          ? _c(
              "div",
              { staticClass: "content-area__content" },
              [
                _c("vue-title", {
                  attrs: {
                    title: _vm.$t(
                      "identityProvider:fraudControl:challenge:title"
                    )
                  }
                }),
                _vm._v(" "),
                _c("h1", { staticClass: "section-title" }, [
                  _vm._v(
                    _vm._s(
                      _vm.$t("identityProvider:fraudControl:challenge:title")
                    )
                  )
                ]),
                _vm._v(" "),
                _c(
                  "form",
                  {
                    ref: "form",
                    attrs: { action: "forcechallenge/index" },
                    on: {
                      submit: function($event) {
                        $event.preventDefault()
                        return _vm.validateBeforeSubmit.apply(null, arguments)
                      }
                    }
                  },
                  [
                    _vm.model.showError && !_vm.errors.any()
                      ? _c(
                          "div",
                          {
                            staticClass:
                              "validation-summary-errors alert alert-danger fade show",
                            attrs: {
                              role: "alert",
                              "data-valmsg-summary": "true",
                              "data-test-element":
                                "idp-alert-danger-secureNow-challenge"
                            }
                          },
                          [
                            _c("i", { staticClass: "material-icons" }, [
                              _vm._v("warning")
                            ]),
                            _vm._v(" "),
                            _vm.model.errorMessage
                              ? _c("span", [
                                  _vm._v(_vm._s(_vm.model.errorMessage))
                                ])
                              : _c(
                                  "span",
                                  {
                                    staticClass: "alert-message",
                                    attrs: {
                                      "data-test-element": "alert-message"
                                    }
                                  },
                                  [_vm._v(_vm._s(_vm.$t("validation:summary")))]
                                )
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.errors.any(),
                            expression: "errors.any()"
                          }
                        ],
                        staticClass:
                          "validation-summary-errors alert alert-danger fade show",
                        attrs: { role: "alert", "data-valmsg-summary": "true" }
                      },
                      [
                        _c("i", { staticClass: "material-icons" }, [
                          _vm._v("warning")
                        ]),
                        _vm._v(" "),
                        _vm.errors.has(".")
                          ? _c("span", [_vm._v(_vm._s(_vm.errors.first(".")))])
                          : _c(
                              "span",
                              {
                                staticClass: "alert-message",
                                attrs: { "data-test-element": "alert-message" }
                              },
                              [_vm._v(_vm._s(_vm.$t("validation:summary")))]
                            )
                      ]
                    ),
                    _vm._v(" "),
                    _c("fieldset", { staticClass: "panel" }, [
                      _c("div", { staticClass: "panel-message" }, [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              _vm.$t(
                                "identityProvider:fraudControl:challenge:instructions"
                              )
                            ) +
                            "\n        "
                        )
                      ]),
                      _vm._v(" "),
                      _c("div", [
                        _c("div", { staticClass: "form-group" }, [
                          _c(
                            "label",
                            {
                              attrs: {
                                "data-test-element": "challenge-question"
                              }
                            },
                            [
                              _c("span", { staticClass: "label -inline" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      "identityProvider:fraudControl:challenge:prompt"
                                    )
                                  )
                                )
                              ]),
                              _vm._v(
                                "\n              " +
                                  _vm._s(_vm.model.prompt) +
                                  "\n            "
                              )
                            ]
                          )
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "form-group" }, [
                          _c("label", { staticClass: "security-answer" }, [
                            _c("span", { staticClass: "label" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "identityProvider:fraudControl:challenge:answer"
                                  )
                                )
                              )
                            ]),
                            _vm._v(" "),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.model.answer,
                                  expression: "model.answer"
                                },
                                { name: "focus", rawName: "v-focus" },
                                {
                                  name: "validate",
                                  rawName: "v-validate",
                                  value: "required",
                                  expression: "'required'"
                                }
                              ],
                              ref: "answer",
                              staticClass: "control",
                              class: {
                                "input-validation-error": _vm.hasErrorOn(
                                  "Answer"
                                )
                              },
                              attrs: {
                                type: "password",
                                name: "Answer",
                                "data-test-element": "Answer",
                                "data-vv-as": _vm.$t(
                                  "identityProvider:fraudControl:challenge:answer"
                                ),
                                autocomplete: "off"
                              },
                              domProps: { value: _vm.model.answer },
                              on: {
                                input: function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.$set(
                                    _vm.model,
                                    "answer",
                                    $event.target.value
                                  )
                                }
                              }
                            }),
                            _vm._v(" "),
                            _c(
                              "span",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.hasErrorOn("Answer"),
                                    expression: "hasErrorOn('Answer')"
                                  }
                                ],
                                staticClass: "field-validation-error"
                              },
                              [_vm._v(_vm._s(_vm.errors.first("Answer")))]
                            )
                          ]),
                          _vm._v(" "),
                          _c("label", { staticClass: "show-answer checkbox" }, [
                            _c("input", {
                              attrs: {
                                type: "checkbox",
                                "data-test-element": "checkbox"
                              },
                              on: { change: _vm.changeVisibility }
                            }),
                            _vm._v(" "),
                            _c("i", {
                              staticClass: "material-icons checkbox-icon"
                            }),
                            _vm._v(
                              "\n              " +
                                _vm._s(_vm.$t("shared:action:showAnswer")) +
                                "\n            "
                            )
                          ])
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "form-actions" }, [
                          _c(
                            "button",
                            {
                              staticClass: "button",
                              attrs: {
                                type: "submit",
                                name: "Action:SecurityQuestion",
                                "data-test-element": "submitBtn",
                                disabled: _vm.disabled
                              }
                            },
                            [_vm._v(_vm._s(_vm.$t("shared:action:continue")))]
                          ),
                          _vm._v(" "),
                          _c(
                            "a",
                            {
                              staticClass:
                                "link link-text-transform button-secondary",
                              attrs: { href: "forcechallenge/cancel" },
                              on: {
                                click: function($event) {
                                  $event.preventDefault()
                                  return _vm.cancelChallenge.apply(
                                    null,
                                    arguments
                                  )
                                }
                              }
                            },
                            [_vm._v(_vm._s(_vm.$t("shared:action:cancel")))]
                          )
                        ])
                      ])
                    ])
                  ]
                )
              ],
              1
            )
          : _c("div", [_c("selectphones-component")], 1)
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-55c47afb", { render: render, staticRenderFns: staticRenderFns })
  }
}